import { ReactNode, useEffect, useRef } from 'react';
import styled from 'styled-components';

interface Props {
  enabled?: boolean;
  once?: boolean;
  children: ReactNode;
  onImpressionLog: () => void;
}

const ImpressionLoggerWithCallback = (props: Props) => {
  const { enabled = true, once = false } = props;
  const shouldLog = useRef<boolean>(true);
  const itemRef = useRef<HTMLDivElement>(null);

  const setLoggingEnabled = () => {
    shouldLog.current = true;
  };

  const setLoggingDisabled = () => {
    shouldLog.current = false;
  };

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        if (!shouldLog.current) {
          return;
        }

        if (once) {
          setLoggingDisabled();
        }

        props.onImpressionLog();
      });
    });

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, [enabled, props.onImpressionLog]);

  useEffect(() => {
    setLoggingEnabled();

    return () => {
      setLoggingDisabled();
    };
  }, []);

  return <Wrapper ref={itemRef}>{props.children}</Wrapper>;
};

export default ImpressionLoggerWithCallback;

const Wrapper = styled.div``;
